import ApiGateway from "../../explorer/services/ApiGateway";
import { SystemService } from "../../explorer/services/SystemService";
import { Basket } from "../../explorer/types/";
import { endpoints } from "../configuration/endpoints";

export class CustomSystemService extends SystemService {}
